let initialState = null;
function history(state = initialState, action) {
  if (action.type === "UPDATE_HISTORY") {
    return action.res;
  } else if (action.type === "RESET_HISTORY") {
    return null;
  } else {
    return state;
  }
}

export default history;
